import axios, { AxiosPromise } from 'axios'
import { MChatPerguntaRespostaInput, MChatRiscoEnum } from 'graphql/types.generated'
import { ConsultaSeguimentoResultadoEnum } from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/model-consultaSeguimento'

export interface ImpressaoAcompanhamentoMChatInput {
  atendProfId: ID
  cidadaoId: ID
  resultado?: number
  risco?: MChatRiscoEnum
  aplicacao?: Array<MChatPerguntaRespostaInput>
  totalPerguntasRespondidas?: number
  totalPerguntasFalhou?: number
  totalPerguntasPassou?: number
  resultadoSeguimento?: ConsultaSeguimentoResultadoEnum
}

export class ImpressaoMChat {
  imprimirMChat(input: ImpressaoAcompanhamentoMChatInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirMChat', input, { responseType: 'blob' })
  }
}
